import React, { memo } from 'react';
import Link from 'next/link';

import { INTERNAL_ROUTES } from '@helpers/route';
import Truck from '@views/static/truck.svg';
import Heart from '@views/static/heart.svg';
import Report from '@views/static/report.svg';
import Info from '@views/static/icon-info.svg';

import { Container, ToggleButton } from './styled';
import { useData } from './utils';

import cn from 'classnames';
import {
  EVENT_CLASS_NAME,
  EVENT_ACTION_NAME,
  EVENT_CATEGORY,
  EVENT_LABEL,
} from '@helpers/events';

const Navigation = memo(() => {
  const { inProp, handleRouteInterest, handleToggleInProp } = useData();

  return (
    <Container in={inProp}>
      <ToggleButton
        onClick={handleToggleInProp}
        className={cn(EVENT_CLASS_NAME)}
        data-category={EVENT_CATEGORY.ACTION}
        data-action={EVENT_ACTION_NAME}
        data-label={EVENT_LABEL.STICKY_HELPER_ACTION}
      >
        {inProp === 'in' ? 'Hỗ trợ nhanh' : 'Đóng'}
      </ToggleButton>
      <ul>
        <li>
          <Link href={INTERNAL_ROUTES.CHECKING_ORDER} passHref>
            <a
              className={cn(EVENT_CLASS_NAME)}
              data-category={EVENT_CATEGORY.ACTION_HELPER}
              data-action={EVENT_ACTION_NAME}
              data-label="Đơn hàng"
            >
              <Truck />
              <span>Đơn hàng</span>
            </a>
          </Link>
        </li>

        <li>
          <a
            href={INTERNAL_ROUTES.INTEREST_PRODUCT}
            onClick={handleRouteInterest}
            className={cn(EVENT_CLASS_NAME)}
            data-category={EVENT_CATEGORY.ACTION_HELPER}
            data-action={EVENT_ACTION_NAME}
            data-label="Yêu thích"
          >
            <Heart />
            <span>Yêu thích</span>
          </a>
        </li>

        <li>
          <Link href={INTERNAL_ROUTES.QUOTATION} passHref>
            <a
              className={cn(EVENT_CLASS_NAME)}
              data-category={EVENT_CATEGORY.ACTION_HELPER}
              data-action={EVENT_ACTION_NAME}
              data-label="Báo giá"
            >
              <Report />
              <span>Báo giá</span>
            </a>
          </Link>
        </li>

        <li>
          <Link
            href="/bai-viet/cau-hoi-thuong-gap-ve-van-phong-pham-faqs"
            passHref
          >
            <a
              className={cn(EVENT_CLASS_NAME)}
              data-category={EVENT_CATEGORY.ACTION_HELPER}
              data-action={EVENT_ACTION_NAME}
              data-label="Trợ giúp"
            >
              <Info />
              <span>Trợ giúp</span>
            </a>
          </Link>
        </li>
      </ul>
    </Container>
  );
});

export default Navigation;
